export class Draft{

    constructor(){
        this.AccountForTransfer = new BankInformation();
        this.BalanceAvailableForWithdrawal = 0;
        this.WithdrawalValue = 0;
        this.DateLimitTransfer = new Date();
        this.IdCustomerExternal = 0;
        this.IdCustomer = 0;
        this.Id = "";
    }
  BalanceAvailableForWithdrawal: number;
  WithdrawalValue: number;
  AccountForTransfer: BankInformation;
  DateLimitTransfer: Date;
  IdCustomerExternal: number;
  IdCustomer: number;
  Id: string
}

class BankInformation{   

    constructor(){
        this.BankCode = 0;
        this.BankName = "";
        this.Agency = "";
        this.Account = "";
        this.DigitAccount = "";
        this.AccountType = "";
        this.CoOwnerName = "";
        this.CoOwnerCPF = "";
        this.IdCustomer = 0;
        this.Id = "";
    } 
    BankCode: number;
    BankName: string;
    Agency: string;
    Account: string;
    DigitAccount: string;
    AccountType: string;
    CoOwnerName: string;
    CoOwnerCPF: string;
    IdCustomer: number;
    Id: string  
}